<button style="outline: none;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass"
  [mat-dialog-close]="true" id="closeBtn">
  <img src="../../../assets/icons/x-button.svg">
</button>
<div class="confir_sec">

  <div class="d-flex justify-content-between mt-3">
      <span class="player-joined">Players Joined</span>
      <span class="player-joined total-team">{{playersList?.length ? playersList?.length : 0}}</span>
  </div>

  <div class="mt-3 players-list">
      <ul>
        <li *ngFor="let player of playersList">
            <span><img [src]="player?.profilePicture ? player?.profilePicture : '../../../assets/icons/img_avatar.png'" alt="" class="player-img"></span>
            <span class="playerName">{{player?.firstName}} {{player?.lastName}}</span>
        </li>
      </ul>
  </div>

  <mat-dialog-actions style=" gap: 30px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'teamdelete'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="DeletBtnClick()" [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 30px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'cancelOrder'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="logoutClick()" [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>
</div>
